import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breadcrumb-work-order-detail',
    templateUrl: './breadcrumb.work.order.detail.component.html'
})

export class BreadcrumbWorkOrderDetailComponent {

    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() viewType: number;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}
